import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";
import {getPowerSourcesData, IPowerSource} from "../../../../data/data";
import PowerSource from "./PowerSource";


interface IPowerSourcesProps
{

}

import './PowerSources.scss';


class PowerSources extends React.Component<IPowerSourcesProps, null>
{
    constructor(public props: IPowerSourcesProps)
    {
        super(props);
    }


    getPowerSources = () : JSX.Element[] =>
    {
        //  get the list of power sources

        const power_sources: IPowerSource[] = getPowerSourcesData();

        return _.map(power_sources, (power_source: IPowerSource, i: number) =>
        {
            return <PowerSource {...power_source} key={i}/>
        })
    };


    render()
    {
        return <div styleName={'power-sources'}>

            {this.getPowerSources()}

        </div>
    }
}


const mapStateToProps = state =>
{
    return {}
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerSources);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/power-sources/PowerSources.tsx